export default __webpack_public_path__ + "static/desk02-9ca27958ec4fd7355dc559cada825e1e.png";